export default "__VITE_ASSET__C$jJT8OU__"